<template>
  <div class="animated fadeIn">
    <div class="top-BG"></div>
    <div class="container">
      <div class="row pt-2">
        <div style="color: white" class="col-12 text-center">Bem-vindo ao nxCoop!</div>
        <div style="color: white" class="col-12 text-center pt-3"><h3>Selecione a área desejada!</h3></div>
      </div>
      <div class="row pt-4 pb-3">
        <div class="col-12 text-center">
          <b-card-group deck>
            <b-card v-if="!hasRole(roles.USUARIO_EXTERNO)" class="text-center pb-2 pointer" style="max-width: 20rem;" @click="onGoToAssociate">
              <i class="fas fa-users pt-4 text-third" style="font-size: 70px" />
              <h4 class="pt-3 ">Associados</h4>
              <!-- <div>Gestão de cooperados</div> -->
            </b-card>

            <b-card class="text-center pb-2 pointer" style="max-width: 20rem;" @click="onGoToCRM" v-if="hasModuleKanban">
              <i class="fas fa-address-card pt-4 text-third" style="font-size: 70px" />
              <h4 class="pt-3 ">CRM</h4>
              <!-- <div>Gestão de oportunidades</div> -->
            </b-card>

            <b-card class="text-center pb-2 pointer" style="max-width: 20rem;" @click="onGoToListas">
              <b-badge variant="primary" style="display: block;position: absolute;right: 10px;top: 10px;">Novo</b-badge>
              <i class="fas fa-clipboard-list pt-4 text-third" style="font-size: 70px" />
              <h4 class="pt-3 ">Listas Inteligentes</h4>
            </b-card>

            <b-card class="text-center pb-2 pointer" style="max-width: 20rem;" @click="onGoToCobranca" v-if="hasModuleKanban">
              <b-badge variant="primary" style="display: block;position: absolute;right: 10px;top: 10px;">Novo</b-badge>
              <i class="fas fa-file-invoice-dollar pt-4 text-third" style="font-size: 70px" />
              <h4 class="pt-3 ">Cobrança</h4>
            </b-card>

            <b-card class="text-center pb-2 pointer" style="max-width: 20rem;" @click.prevent="onGoToVisitas" v-if="!hasRole(roles.USUARIO_EXTERNO)">
              <b-badge variant="primary" style="display: block;position: absolute;right: 10px;top: 10px;">Novo</b-badge>
              <i class="fas fa-map-marked-alt pt-4 text-third" style="font-size: 70px" />
              <h4 class="pt-3 ">Visitas</h4>
            </b-card>

            <b-card class="text-center pb-2 pointer" style="max-width: 20rem;" @click.prevent="onGoToCampaign" v-if="!hasRole(roles.USUARIO_EXTERNO)">
              <!-- <b-badge variant="primary" style="display: block;position: absolute;right: 10px;top: 10px;">Novo</b-badge> -->
              <i class="fas fa-bullhorn pt-4 text-third" style="font-size: 70px" />
              <h4 class="pt-3 ">Campanha</h4>
              <!-- <div>Gestão de campanha</div> -->
            </b-card>

            <b-card class="text-center pb-2 pointer d-none" style="max-width: 20rem;" @click="onGoToTShield" v-if="tShieldClient && !hasRole(roles.USUARIO_EXTERNO)">
              <i class="fas fa-users-cog pt-3 text-third" style="font-size: 70px" />
              <h4 class="pt-3 ">Análise</h4>
              <!-- <div>Validação para novos cooperados</div> -->
            </b-card>
            <b-card v-if="hasRole(roles.IMPORTACAO_PLANILHA)" class="text-center pb-2 pointer d-none" style="max-width: 20rem;" @click="onGoToImports">
              <i class="fas fa-file-import pt-3 text-third" style="font-size: 70px" />
              <h4 class="pt-4 ">Importação</h4>
              <!-- <div>Integração com a Cooperativa</div> -->
            </b-card>
          </b-card-group>
        </div>
      </div>
      <div v-if="!this.hasRole(this.roles.USUARIO_EXTERNO)" class="row pt-4">
        <template v-if="isTablet">
          <div class="col-12 pb-4">
            <DetailContainer componentTitle="Aniversariantes" componentIcon="fas fa-gift">
              <BirthdayTable />
            </DetailContainer>
          </div>
        </template>
        <template v-else>
          <div :class="canSeeAssociates  ? 'col-6' : 'col-12'">
            <DetailContainer componentTitle="Aniversariantes" componentIcon="fas fa-gift">
              <BirthdayTable />
            </DetailContainer>
          </div>
        </template>
        <div :class="isTablet ? 'col-12' : 'col-6'" v-if="canSeeAssociates">
          <DetailContainer componentTitle="Não Carteirizados" componentIcon="fas fa-users" >
            <WithoutManagerTable />
          </DetailContainer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import DetailContainer from '../crm/components/detailContainer/detailContainer'
import BirthdayTable from '@/views/private/StartPage/BirthdayTable.vue'
import WithoutManagerTable from './WithoutManagerTable.vue'

export default {
  name: 'StartPage',
  mixins: [ActionsForm],
  components: {
    DetailContainer,
    BirthdayTable,
    WithoutManagerTable
  },
  data () {
    return {
      tShieldClient: process.env.TShieldClient,
      hasModuleKanban: process.env.hasKanban,
      isTablet: screen.width <= 768
    }
  },
  mounted () {
    this.RemoveMinimizedSidebar()
  },
  computed: {
    canSeeAssociates () {
      return (
        this.hasRole(this.roles.MOVIMENTACAO) ||
        this.hasRole(this.roles.ADMINISTRADOR)
      )
    }
  },
  methods: {
    onLoad () {},
    onGoToAssociate () {
      this.$router.push({ name: 'Associate' })
    },
    onGoToCRM () {
      this.$router.push({ name: 'CRM' })
    },
    onGoToCobranca () {
      this.$router.push({ name: 'Cobrança' })
    },
    onGoToListas () {
      this.$router.push({ name: 'ListaInteligente' })
    },
    onGoToTShield () {
      this.$router.push({ name: 'CadastroTShield' })
    },
    onGoToImports () {
      this.$router.push({ name: 'Importacao' })
    },
    onGoToCampaign () {
      this.$router.push({ name: 'Campanha' })
    },
    onGoToVisitas () {
      this.$router.push({ name: 'Visitas' })
    },
    RemoveMinimizedSidebar: function () {
      document.body.classList.remove('sidebar-minimized')
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style scoped>

.pt-3 h4{
  font-size: 1.2rem !important;
  word-break: keep-all;
}
.card {
  border-radius: 11px;
  box-shadow: 0 0 1em #ccc;
}
h4 {
  font-size: 1.15rem !important;
  font-weight: bold;
}
.pointer {
  cursor: pointer;
}
.card-body{
  padding: .25rem;
}

.top-BG {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 45vh;

  background: linear-gradient(90deg, #2dce89 0%, #2dcecc 100%);
}
</style>



// WEBPACK FOOTER //
// src/views/private/StartPage/StartPage.vue